import { useEffect } from "react";
import { useStore } from "@/lib/store";

export function ApprovalDialog() {
  const pending = useStore((s) => s.pendingApproval);
  const resolve = useStore((s) => s.resolveApproval);

  useEffect(() => {
    if (!pending) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") resolve("deny");
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [pending, resolve]);

  if (!pending) return null;

  const prefix = pending.command.trim().split(/\s+/).slice(0, 2).join(" ");

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-lg rounded-lg border bg-background p-5 shadow-xl">
        <div className="mb-2 flex items-center gap-2">
          <i className="fa-solid fa-terminal text-orange-500" />
          <h2 className="text-base font-semibold">Approve shell command?</h2>
        </div>
        <p className="mb-3 text-xs text-muted-foreground">
          The assistant wants to run a command in <span className="font-mono">{pending.workspacePath}</span>
        </p>
        <pre className="mb-4 max-h-40 overflow-auto rounded-md border bg-muted/50 px-3 py-2 text-xs font-mono whitespace-pre-wrap break-all">
          {pending.command}
        </pre>
        <div className="flex flex-wrap items-center justify-end gap-2">
          <button
            onClick={() => resolve("deny")}
            className="rounded-md border px-3 py-1.5 text-sm hover:bg-muted"
          >
            Deny
          </button>
          <button
            onClick={() => resolve("once")}
            className="rounded-md border bg-muted px-3 py-1.5 text-sm hover:bg-muted/70"
          >
            Approve once
          </button>
          <button
            onClick={() => resolve("always")}
            className="rounded-md bg-orange-500 px-3 py-1.5 text-sm text-white hover:bg-orange-500/90"
            title={`Whitelists commands starting with "${prefix}"`}
          >
            Always for "{prefix}"
          </button>
        </div>
      </div>
    </div>
  );
}
